import { useDispatch } from 'react-redux';
import { privateTemplateTagAPI } from '../../../../entities/template/private-template-tag';
import {
	notificationError,
	notificationSuccess,
	notificationWarning,
} from '../../../../components/Notifications/callNotifcation';
import { templateTagGroupApi } from '../../../../entities/template/private-template-tag-group';

export const useCreatePrivateTemplateTag = () => {
	const dispatch = useDispatch();

	const [createTag, { isLoading }] = privateTemplateTagAPI.useCreateMutation();
	const { data: existingTags } = privateTemplateTagAPI.useGetAllQuery({ limit: 127, page: 1 });

	const onCreateTag = async (name: string) => {
		try {
			const tagNames = existingTags?.templateTags?.map((tag) => tag.name.toLowerCase()) ?? [];

			if (tagNames.length > 0 && tagNames.includes(name.toLowerCase())) {
				notificationWarning('Создание тега', `Тег с именем "${name}" уже существует`);
				return null;
			}

			const res = await createTag({ name }).unwrap();

			dispatch(templateTagGroupApi.util?.invalidateTags(['templateTagGroup']));
			dispatch(privateTemplateTagAPI.util?.invalidateTags(['template_tags']));

			notificationSuccess('Тег создан успешно');
			return res.tag;
		} catch (e) {
			notificationError('Произошла ошибка при создании тега...');
			console.log(e);
			return null;
		}
	};

	return {
		isLoading,
		onCreateTag,
	};
};
